var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass:
        "md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass:
                "md:flex md:justify-center md:pb-2 text-blue-600 mr-0 inline-block px-0",
              attrs: { to: { name: "Dashboard" } }
            },
            [
              _c("img", {
                staticClass: "w-1/3",
                attrs: { src: require("@/assets/musicverse-logo.png") }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "md:hidden items-center flex flex-wrap list-none" },
            [
              _c(
                "li",
                { staticClass: "inline-block relative" },
                [_c("user-dropdown")],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-0 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded",
              class: _vm.collapseShow
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200"
                },
                [
                  _c("div", { staticClass: "flex flex-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "w-6/12" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "md:block text-left md:pb-2 text-blue-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0",
                            attrs: { to: { name: "Dashboard" } }
                          },
                          [
                            _c("img", {
                              staticClass: "w-full",
                              attrs: {
                                src: require("@/assets/musicverse-logo.png")
                              }
                            })
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "w-6/12 flex justify-end" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.toggleCollapseShow("hidden")
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-times" })]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("hr", { staticClass: "my-4 md:min-w-full" }),
              _vm._v(" "),
              _c(
                "h6",
                {
                  staticClass:
                    "md:min-w-full text-gray-600 text-xs text-left uppercase font-bold block pt-1 pb-4 no-underline"
                },
                [_vm._v("\n          Menu Navigation\n        ")]
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass:
                    "md:flex-col md:min-w-full flex flex-col list-none"
                },
                [
                  !_vm.isReviewer && !_vm.isRecruitment && !_vm.isFinance
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "Statistic" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.currentRoute === "Statistic"
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-chart-line mr-2 text-sm"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Home")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              588798515
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "AdsSettings" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isAppSettingMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-cog mr-2 text-sm"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("App Settings")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              70279626
                            )
                          }),
                          _vm._v(" "),
                          _vm.isAppSettingMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "AdsSettings" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "AdsSettings"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Ads")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1873438378
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "AccountDeletionSurvey" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "AccountDeletionSurvey"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Account Deletion Survey"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1240441263
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "HomeSection" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "HomeSection"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Home Section")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          4220088335
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "OnboardingBanner" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "OnboardingBanner"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Onboarding Banner"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1082082223
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "ReferralBanner" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "ReferralBanner"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Referral Banner"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          364853807
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "ReferralAbout" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "ReferralAbout"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Referral About"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2837408655
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "MusicCategoriesPage" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isCategoriesMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-list-ul mr-2 text-sm"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Categories")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1874246148
                            )
                          }),
                          _vm._v(" "),
                          _vm.isCategoriesMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "MusicCategoriesPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "MusicCategoriesPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Music Categories"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3995092988
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "MissionCategoriesPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "MissionCategoriesPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Missions Videos Categories"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1713828877
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: "/missions-videos" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isMissionsVideosMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-video mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Missions Videos")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2761448820
                            )
                          }),
                          _vm._v(" "),
                          _vm.isMissionsVideosMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "ChannelListPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "ChannelListPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Channel List")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2886143222
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "RecommendedVideosPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "RecommendedVideosPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Recommended Video"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3708800677
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "VideoPageSection" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                          "VideoPageSection" ||
                                                        _vm.currentRoute ===
                                                          "VideoPageDetail"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Video Page")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2940534642
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAdmin || _vm.isSuperAdmin || _vm.isReviewer
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "ListPlaylist" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isPlaylistMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-play-circle mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Playlist")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1299603294
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "Users" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isUserMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-users mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Users")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              35017703
                            )
                          }),
                          _vm._v(" "),
                          _vm.isUserMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "Users" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "Users"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("App Users")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1761560004
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "UsersAdmin" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "UsersAdmin"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Admin Users")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3265809861
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "UsersDeletedPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "UsersDeletedPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Deleted App Users"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          4122101783
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps ||
                  _vm.isAdmin ||
                  _vm.isSuperAdmin ||
                  _vm.isRecruitment
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "Artists" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isArtistManagementMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-drum mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Artists")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              514391864
                            )
                          }),
                          _vm._v(" "),
                          _vm.isArtistManagementMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "Artists" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                          "Artists" ||
                                                        _vm.currentRoute ===
                                                          "DetailArtistPage" ||
                                                        _vm.currentRoute ===
                                                          "AddArtistPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Artist List")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          660149732
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "DraftArtistPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "DraftArtistPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Draft")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3731743679
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "ArtistOnboardingPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                          "ArtistOnboardingPage" ||
                                                        _vm.currentRoute ===
                                                          "ArtistApplicationDetailPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Onboarding")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3520357827
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isFinance
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: {
                              to: {
                                name: _vm.isArtist ? "Album" : "SongManagement"
                              }
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isAlbumMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-music mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Content")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1598500521
                            )
                          }),
                          _vm._v(" "),
                          _vm.isAlbumMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  !_vm.isArtist
                                    ? _c(
                                        "li",
                                        { staticClass: "items-center" },
                                        [
                                          _c("router-link", {
                                            attrs: {
                                              to: { name: "SongManagement" }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var href = ref.href
                                                    var navigate = ref.navigate
                                                    var isActive = ref.isActive
                                                    return [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "text-sm uppercase py-3 font-bold block text-left",
                                                          class: [
                                                            _vm.currentRoute ===
                                                            "SongManagement"
                                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                              : "text-gray-800 hover:text-gray-600"
                                                          ],
                                                          attrs: { href: href },
                                                          on: {
                                                            click: navigate
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-xs"
                                                            },
                                                            [_vm._v("Songs")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              3901105349
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "Album" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "Album"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Album")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3981547749
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.isArtist
                                    ? _c(
                                        "li",
                                        { staticClass: "items-center" },
                                        [
                                          _c("router-link", {
                                            attrs: {
                                              to: { name: "ArtistsBio" }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var href = ref.href
                                                    var navigate = ref.navigate
                                                    var isActive = ref.isActive
                                                    return [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "text-sm uppercase py-3 font-bold block text-left",
                                                          class: [
                                                            _vm.currentRoute ===
                                                            "ArtistsBio"
                                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                              : "text-gray-800 hover:text-gray-600"
                                                          ],
                                                          attrs: { href: href },
                                                          on: {
                                                            click: navigate
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "text-xs"
                                                            },
                                                            [_vm._v("Bio")]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              2069216959
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isArtist
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "PurchaseListPage" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isTransactionsMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-chart-bar mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Transactions")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              4097337909
                            )
                          }),
                          _vm._v(" "),
                          _vm.isTransactionsMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "StreamListPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "StreamListPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Stream")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1682694676
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "Transactions" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "Transactions"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Purchase")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2190916441
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "EarningPage" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "EarningPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Earnings")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          648011397
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "TncManagement" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.currentRoute === "TncManagement"
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-file-contract mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Term of Service")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1603830792
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "CreditsAmount" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isPricingMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-money-bill mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Pricing")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3338320147
                            )
                          }),
                          _vm._v(" "),
                          _vm.isPricingMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "CreditsAmount" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "CreditsAmount"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Credits Amount"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3584499909
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: {
                                            name: "SubscriptionSettingPage"
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "SubscriptionSettingPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Subscription")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2972277344
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "IapManagement" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "IapManagement"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "In-App Purchase"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1999788910
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "TransactionHistoryPage" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isTransactionsAdminMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-clipboard-list mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Transactions")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1546531433
                            )
                          }),
                          _vm._v(" "),
                          _vm.isTransactionsAdminMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "TransactionHistoryPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "TransactionHistoryPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Content Purchase"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1056821650
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "CreditPurchasePage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "CreditPurchasePage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Credit Purchase"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1023385846
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: {
                                            name: "SubscriptionHistoryPage"
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "SubscriptionHistoryPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Subscription")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          4144217140
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "RedemptionHistoryPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "RedemptionHistoryPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Redemption")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1090158260
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isArtist && !_vm.isRecruitment && !_vm.isReviewer
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "PayoutList" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isFinanceMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-chart-bar mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Finance")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              546054790
                            )
                          }),
                          _vm._v(" "),
                          _vm.isFinanceMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "PayoutList" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "PayoutList"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Payout List")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1187949285
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "PayoutDashboard" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "PayoutDashboard"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Payout Dashboard"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          914360581
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "TransferHistory" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "TransferHistory"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Transfer History"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1750695397
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "RatingList" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isRatingSurveyMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-star mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Rating and Survey")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1928484873
                            )
                          }),
                          _vm._v(" "),
                          _vm.isRatingSurveyMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "RatingList" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "RatingList"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Ratings")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          372090292
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: { to: { name: "SurveyList" } },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "SurveyList"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Survey")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          39737255
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "ReferralDataBannerPage" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isReferralDataMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-users mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Referral Data")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1782360564
                            )
                          }),
                          _vm._v(" "),
                          _vm.isReferralDataMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "ReferralDataBannerPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "ReferralDataBannerPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Banner Click")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3579544017
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "ReferralDataSharePage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "ReferralDataSharePage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("Share Click")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1452522609
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "ReferralDataMemberPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "ReferralDataMemberPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Referred Member"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          655777706
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isOps || _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "FirstTimeSubsPage" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.isSubscriptionMenu
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-users mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Subscription")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2751310132
                            )
                          }),
                          _vm._v(" "),
                          _vm.isSubscriptionMenu
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "md:flex-col md:min-w-full flex flex-col list-none ml-5"
                                },
                                [
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "FirstTimeSubsPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "FirstTimeSubsPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [_vm._v("First Time")]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          2515681089
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "li",
                                    { staticClass: "items-center" },
                                    [
                                      _c("router-link", {
                                        attrs: {
                                          to: { name: "CancelExpireSubsPage" }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var href = ref.href
                                                var navigate = ref.navigate
                                                var isActive = ref.isActive
                                                return [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "text-sm uppercase py-3 font-bold block text-left",
                                                      class: [
                                                        _vm.currentRoute ===
                                                        "CancelExpireSubsPage"
                                                          ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                                          : "text-gray-800 hover:text-gray-600"
                                                      ],
                                                      attrs: { href: href },
                                                      on: { click: navigate }
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "text-xs"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Cancel & Expire"
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          838095751
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "CLTVPage" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.currentRoute === "CLTVPage"
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-users mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("CLTV")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1874128547
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAdmin || _vm.isSuperAdmin
                    ? _c(
                        "li",
                        { staticClass: "items-center" },
                        [
                          _c("router-link", {
                            attrs: { to: { name: "UsersPremium" } },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var href = ref.href
                                    var navigate = ref.navigate
                                    var isActive = ref.isActive
                                    return [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "text-sm uppercase py-3 font-bold block text-left",
                                          class: [
                                            _vm.currentRoute === "UsersPremium"
                                              ? "text-blue-700 hover:text-blue-500 border-b-2 border-gray-800"
                                              : "text-gray-800 hover:text-gray-600"
                                          ],
                                          attrs: { href: href },
                                          on: { click: navigate }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa fa-crown mr-2 text-sm"
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-xs" },
                                            [_vm._v("Premium Users")]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              326965237
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass:
          "cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent",
        attrs: { type: "button" }
      },
      [_c("i", { staticClass: "fas fa-bars" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b089832", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b089832","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/SideBar.vue
// module id = null
// module chunks = 